module.exports = __webpack_public_path__ + "img/全部取消.e709276f.svg";